module.exports = MessageFormat;


/*****************
 ** WEBPACK FOOTER
 ** external "MessageFormat"
 ** module id = 260
 ** module chunks = 0
 **/